import '.cc{position:relative;}.ssr-plugin'
import '.j6{width:64px;}.ssr-plugin'
import '.j7{height:64px;}.ssr-plugin'
import '.e{flex-shrink:0;}.ssr-plugin'
import '.b7{position:absolute;}.ssr-plugin'
import '.j8{bottom:-4px;}.ssr-plugin'
import '.de{right:-4px;}.ssr-plugin'
import '.ei{border-radius:50%;}.ssr-plugin'
import '.j9{border:2px solid var(--palette-white);}.ssr-plugin'
import '.c{overflow:hidden;}.ssr-plugin'
import '.ja{width:32px;}.ssr-plugin'
import '.jb{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="cc j6 j7 e"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b7 j8 de ei j9 c ja jb"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
